import { zodResolver } from '@hookform/resolvers/zod';
import { useForm } from 'react-hook-form';
import { z } from 'zod';
import UIStrings from '@/Utils/UIStrings';
import ValidationErrors from '@/Utils/ValidationErrors';

export const newTeamMemberSchema = z.object({
    email: z
        .email({ message: ValidationErrors.EmailValidationError })
        .min(1, UIStrings.Required)
        .max(128, { message: UIStrings.MaxSymbolsValidationError(128) }),
    role: z.enum(['Admin'], { error: UIStrings.Required }),
});

export type NewTeamMember = z.infer<typeof newTeamMemberSchema>;

export const useNewTeamMemberForm = () =>
    useForm<NewTeamMember>({
        resolver: zodResolver(newTeamMemberSchema),
        mode: 'onSubmit',
        defaultValues: { email: '', role: 'Admin' },
    });
